import { Link } from 'react-router-dom';

export default function ArticleSection() {
  return (
    <section id="guides" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-12">
          <div>
            <span className="text-xs font-semibold tracking-widest uppercase text-accent-500 mb-3 block">
              Learn & Explore
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              Superbuy Sheet Guides & Resources
            </h2>
          </div>
          <Link
            to="/superbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap group"
          >
            View All Guides
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          <Link
            to="/superbuy-spreadsheet-guide"
            className="group relative bg-foreground-900 rounded-2xl p-6 flex flex-col justify-between overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02] min-h-[280px]"
          >
            <div className="relative z-10">
              <div className="w-10 h-10 rounded-xl bg-background-50/10 flex items-center justify-center mb-4">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-background-50 mb-2 leading-snug">
                Complete Superbuy Sheet Guide 2026
              </h3>
              <p className="text-xs text-background-50/60 leading-relaxed line-clamp-3">
                Everything you need to know about using Superbuy spreadsheets for smart shopping — from finding products to verifying sellers.
              </p>
            </div>
            <div className="relative z-10 flex items-center gap-3 mt-4">
              <span className="text-xs text-background-50/50">12 min read</span>
              <span className="w-1 h-1 rounded-full bg-background-50/30"></span>
              <span className="text-xs text-background-50/50">July 2026</span>
            </div>
            <div className="absolute top-4 right-4 w-24 h-24 rounded-full bg-primary-500/20 blur-2xl"></div>
          </Link>

          <Link
            to="/superbuy-spreadsheet-beginner-guide"
            className="group relative bg-background-50 border border-background-200/60 rounded-2xl p-6 flex flex-col justify-between overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02] min-h-[280px]"
          >
            <div className="relative z-10">
              <div className="w-10 h-10 rounded-xl bg-accent-50 flex items-center justify-center mb-4">
                <i className="ri-user-star-line text-accent-500 text-lg"></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 leading-snug">
                Superbuy Sheet Beginner Guide
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                New to Superbuy spreadsheets? This step-by-step introduction walks you through everything from first browse to first purchase.
              </p>
            </div>
            <div className="relative z-10 flex items-center gap-3 mt-4">
              <span className="text-xs text-foreground-400">14 min read</span>
              <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
              <span className="text-xs text-foreground-400">July 2026</span>
            </div>
          </Link>

          <Link
            to="/superbuy-spreadsheet-shoes-guide"
            className="group relative bg-background-50 border border-background-200/60 rounded-2xl p-6 flex flex-col justify-between overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02] min-h-[280px]"
          >
            <div className="relative z-10">
              <div className="w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center mb-4">
                <i className="ri-footprint-line text-primary-500 text-lg"></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 leading-snug">
                Superbuy Sheet Shoes Guide
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                Deep dive into the #1 Superbuy spreadsheet category. Sneakers, sizing, QC photos, and finding the best footwear deals.
              </p>
            </div>
            <div className="relative z-10 flex items-center gap-3 mt-4">
              <span className="text-xs text-foreground-400">16 min read</span>
              <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
              <span className="text-xs text-foreground-400">July 2026</span>
            </div>
          </Link>

          <Link
            to="/superbuy-spreadsheet-shipping-guide"
            className="group relative bg-background-50 border border-background-200/60 rounded-2xl p-6 flex flex-col justify-between overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02] min-h-[280px]"
          >
            <div className="relative z-10">
              <div className="w-10 h-10 rounded-xl bg-secondary-50 flex items-center justify-center mb-4">
                <i className="ri-ship-line text-secondary-500 text-lg"></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 leading-snug">
                Superbuy Sheet Shipping Guide
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                Slash international shipping costs using Superbuy spreadsheet weight data. Consolidation strategies and carrier comparisons.
              </p>
            </div>
            <div className="relative z-10 flex items-center gap-3 mt-4">
              <span className="text-xs text-foreground-400">13 min read</span>
              <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
              <span className="text-xs text-foreground-400">July 2026</span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}